module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    attrs: {
      "data-scrollbar": "true",
      "data-height": "100%"
    }
  }, [(_vm.auth.scopes) ? _c('div', [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-header"
  }, [_vm._v("Navigation")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])]), _vm._v(" "), (_vm.auth.scopes.includes('admin_userman')) ? _c('usman-nav') : _vm._e(), _vm._v(" "), (
    _vm.auth.scopes.includes('admin_itembank') ||
    _vm.auth.scopes.includes('admin_operational') ||
    _vm.auth.scopes.includes('admin_userman') ||
    _vm.auth.scopes.includes('read_tryout') ||
    _vm.auth.scopes.includes('write_tryout')
  ) ? _c('tryout-members') : _vm._e(), _vm._v(" "), (
    _vm.auth.scopes.includes('admin_itembank') ||
    _vm.auth.scopes.includes('admin_operational')
  ) ? _c('oss-configs-nav') : _vm._e(), _vm._v(" "), (_vm.auth.scopes.includes('admin_itembank')) ? _c('tryoutgroup-nav') : _vm._e(), _vm._v(" "), (
    _vm.auth.scopes.includes('admin_itembank') ||
    _vm.auth.scopes.includes('read_tryout')
  ) ? _c('tryout-nav') : _vm._e(), _vm._v(" "), (_vm.auth.scopes.includes('admin_itembank')) ? _c('serial-nav') : _vm._e(), _vm._v(" "), (_vm.auth.scopes.includes('admin_operational')) ? _c('liveclass-nav') : _vm._e(), _vm._v(" "), (
    _vm.auth.scopes.includes('admin_itembank') ||
    _vm.auth.scopes.includes('admin_operational')
  ) ? _c('modul-belajar') : _vm._e(), _vm._v(" "), (_vm.auth.scopes.includes('admin_itembank')) ? _c('itembank-nav') : _vm._e(), _vm._v(" "), (_vm.auth.scopes.includes('admin_itembank')) ? _c('kodifikasi-nav') : _vm._e(), _vm._v(" "), (_vm.auth.scopes.includes('admin_modul_belajar')) ? _c('modulpembelajaran-nav') : _vm._e(), _vm._v(" "), (_vm.auth.scopes.includes('admin_sales')) ? _c('pembayaran-nav') : _vm._e(), _vm._v(" "), (_vm.auth.scopes.includes('admin_itembank')) ? _c('video-nav') : _vm._e(), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "sidebar-minify-btn",
    attrs: {
      "href": "javascript:;",
      "data-click": "sidebar-minify"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46771fd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/layout/Sidebar.vue
// module id = 2256
// module chunks = 1